<template>
    <div>
        <div v-if="massaged_groups" :style="canvas_width">
            <span v-for="massaged_group in massaged_groups" :style="massaged_group.style">{{massaged_group.label}}</span>
        </div>
    </div>
</template>
<script>
    export default {
        mounted() {
        },
        computed: {
            canvas_width: function() {
                return "margin-left: 54px; margin-right: 21px;margin-top:5px;"
            }
        },
        watch: {
            groups: function () {
                let massaged_groups = []
                let bars_per_group = this.groups['bars_per_group']
                let bar_count = this.groups["bar_count"]
                if (this.groups["group_names"] !== 'ungrouped') {
                    let group_count = this.groups["group_names"].length
                    let group_names = this.groups["group_names"]
                    group_names.forEach(function (group_name) {
                        let massaged_group = {
                            label: group_name,
                            style: "width:" + String((100 - group_count) * bars_per_group[group_name] / bar_count) + "%" + ";text-align:center;background-color:darkgray;color:white;padding: 5 20px;margin-right:1%;display:inline-block;"
                        }
                        massaged_groups.push(massaged_group)
                    });
                    this.massaged_groups = massaged_groups
                } else {
                    this.massaged_groups = null
                }
            }
        },
        props: ['groups'],
        data() {
            return {
                massaged_groups: null
            }
        }
    }
</script>